export interface AppSpecs {
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'true' | 'false';
  'specs.funnel.templatePageUiV2': 'true' | 'false';
  'specs.funnel.templatePageUiV2Fixes': 'true' | 'false';
  'specs.funnel.templatePageUiV2WithAnimation': 'true' | 'false';
  'specs.funnel.TemplatesRemoveSubCategories': 'true' | 'false';
  'specs.funnel.templatePageHideEditButton': 'true' | 'false';
  'specs.funnel.TemplatesViewModal': 'true' | 'false';
}

export const defaultAppSpecs: AppSpecs = {
  'specs.funnel.TemplatesGalleryUseReactDomHydrate': 'false',
  'specs.funnel.templatePageUiV2': 'false',
  'specs.funnel.templatePageUiV2Fixes': 'false',
  'specs.funnel.templatePageUiV2WithAnimation': 'false',
  'specs.funnel.TemplatesRemoveSubCategories': 'false',
  'specs.funnel.templatePageHideEditButton': 'false',
  'specs.funnel.TemplatesViewModal': 'false',
};
